import { FeedbackMessage } from '@sapphire-react/core';
import { Error } from '@sapphire/icons/react';
import { useTranslation } from 'react-i18next';
import { ResultWhiteBox } from '../layout';

type Props = {
  variant?: 'error' | 'warning' | 'informative';
  heading?: string;
  body?: string;
};

export function ErrorMessage({ variant = 'error', heading, body }: Props) {
  const { t } = useTranslation('shared');

  return (
    <ResultWhiteBox>
      <FeedbackMessage
        maxWidth={420}
        variant={variant}
        icon={<Error />}
        heading={heading || t('calculationResult.error.heading')}
        body={body || t('calculationResult.error.description')}
      />
    </ResultWhiteBox>
  );
}
